import { Component, Vue,Inject } from 'vue-property-decorator';
import appconst from './appconst'
export default class AbpBase extends Vue{
    L(value:string,source?:string,...argus:string[]):string{
        if(source){
            return window.abp.localization.localize(value,source,argus);
        }else{
            return window.abp.localization.localize(value,appconst.localization.defaultLocalizationSourceName,argus);
        }
        
    }
    hasPermission(permissionName:string){
        return window.abp.auth.hasPermission(permissionName);
    }
    hasAnyOfPermissions(...argus:string[]){
        return window.abp.auth.hasAnyOfPermissions(...argus);
    }
    hasAllOfPermissions(...argus:string[]){
        return window.abp.auth.hasAllOfPermissions(...argus);
    }
    getTimes(t: number) {
        let h = parseInt((t / 60 / 60 % 24)+'')
        let m = parseInt((t / 60 % 60)+'')
        let s = parseInt((t % 60)+'')
        //三元表达式 补零 如果小于10 则在前边进行补零 如果大于10 则不需要补零
        h = h < 10 ?  h : h
        m = m < 10 ?  m : m
        s = s < 10 ?  s : s

        return `${h == 0 ? '':h + '时' }${m == 0 ? '' : m + '分'}${s == 0 ? '' : s + '秒'}`
    }

    formatDate(date?: Date | undefined, fmt?: string | undefined) {

        if (fmt == undefined) {
            fmt = 'yyyy-MM-dd hh:mm:ss';
        }
        if (date == undefined) {
            return '';
        }
        if (/(y+)/.test(fmt)) {
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
        }
        let o = {
            'M+': date.getMonth() + 1,
            'd+': date.getDate(),
            'h+': date.getHours(),
            'm+': date.getMinutes(),
            's+': date.getSeconds()
        };
        for (let k in o) {
            if (new RegExp(`(${k})`).test(fmt)) {
                let str = o[k] + '';
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? str : this.padLeftZero(str));
            }
        }
        return fmt;
    };
    formatDatea(val, format) {
        let REGEX = /(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})/;
        if (val) {
            /**
             * @instructions 如果不是时间戳格式，且含有字符 '-' 则将 '-' 替换成 '/' && 删除小数点及后面的数字
             * @reason 将 '-' 替换成 '/' && 删除小数点及后面的数字 的原因是safari浏览器仅支持 '/' 隔开的时间格式
             */
            debugger;
            if (val.toString().indexOf('-') > 0) {
                val = val.replace(/T/g, ' ').replace(/\.[\d]{3}Z/, '').replace(/(-)/g, '/') // 将 '-' 替换成 '/'
                val = val.slice(0, val.indexOf('.')) // 删除小数点及后面的数字
            }
            let date = new Date(val)
            date.setHours(date.getHours() + 8)
            const [whole, yy, MM, dd, hh, mm, ss] = date.toISOString().match(REGEX)

            const year = new Date().getFullYear()
            const month = new Date().getMonth() + 1
            const dates = new Date().getDate()
            if (format) {
                return format
                    .replace('yyyy', yy)
                    .replace('yy', yy.slice(2))
                    .replace('MM', MM)
                    .replace('dd', dd)
                    .replace('hh', hh)
                    .replace('mm', mm)
                    .replace('ss', ss)
            } else {
                return [yy, MM, dd].join('-') + ' ' + [hh, mm, ss].join(':')
            }
        } else {
            return '--'
        }
    }
    padLeftZero(str) {
        return ('00' + str).substr(str.length);
    }
    convertUTCTimeToLocalTime(UTCDateString: string) {
        if (!UTCDateString) {
            return '-';
        }

        var date2 = new Date(UTCDateString);     //这步是关键
        var year = date2.getFullYear();
        var mon = this.formatFunc(date2.getMonth() + 1);
        var day = this.formatFunc(date2.getDate());
        var hour = date2.getHours();
        var noon = hour >= 12 ? 'PM' : 'AM';
        hour = hour >= 12 ? hour - 12 : hour;
        hour = this.formatFunc(hour);
        var min = this.formatFunc(date2.getMinutes());
        var dateStr = year + '-' + mon + '-' + day + ' ' + noon + ' ' + hour + ':' + min;
        return dateStr;
    }


    formatFunc(str) {    //格式化显示
        return str > 9 ? str : '0' + str
    }

    setpicurl(url) {
        return appconst.remoteServiceBaseUrl + url;
    }

    addDays(date: Date, days: number): Date {
        return new Date(date.setDate(date.getDate() + days));
    }
    toMoney(e) {
        if (!e) {
            return 0.00;
        }
        return e.toFixed(2)
    }
    querylog(id, logtablename) {
        var log = this.$refs.log as any;
        log.getlist(id, logtablename);
    }
    copyData(data){
        var input = document.createElement('input')
        //将input的值设置为需要复制的内容
        input.value = data;
        //添加input标签
        document.body.appendChild(input)
        //选中input标签
        input.select()
        //执行复制
        document.execCommand('copy')
        //成功提示信息
        this.$Notice.success({title:'复制成功'})
        //移除input标签
        document.body.removeChild(input)
      }
    header = {
        Authorization: 'Bearer ' + window.abp.auth.getToken()
      };
    tradecheck = [
        { value: "tid", label: "订单号" },
        {value:'buyerNick',label:'买家昵称'},
        {value:'receiverName', label:'收货人姓名'},
        {value:'receiverMobile',label:'收货人手机号'},
        {value:'address',label:'收货人地址'}
    ]
    tradestate=[
        {value:"0",label:"待付款"},
        {value:"1",label:"待发货"},
        {value:"2",label:"已发货"},
        {value:"3",label:"已完成"},
        {value:"4",label:"订单关闭"},
        {value:"5",label:"取消订单"}
    ]
    refundstates=[
        {id:1,label:'买家申请退款'},
        {id:2,label:'商家同意退款'},
        {id:3,label:'买家取消退款'},
        {id:99,label:'商家拒绝退款'}
    ]
}